import { render, staticRenderFns } from "./AmProfilePhoto.vue?vue&type=template&id=0e4b1ac8&scoped=true&"
import script from "./AmProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./AmProfilePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4b1ac8",
  null
  
)

export default component.exports